export default __webpack_public_path__ + "static/media/AG12.2e0d6599.mp3";